module.exports = __webpack_public_path__ + "img/Frame 31.fdd94e88.png";